import React from 'react';
import { ITEM_IMG_SIZE } from '../../constants/general';
var ItemImage = function (_a) {
    var imageUrl = _a.imageUrl, itemDescription = _a.itemDescription, margin = _a.margin;
    var className = "sui-shrink-0 ".concat(margin ? 'sui-mr-4' : '');
    return (React.createElement("div", { className: className, "data-testid": "item-image" },
        React.createElement("img", { src: imageUrl || 'https://assets.thdstatic.com/images/v1/no-img.svg', height: ITEM_IMG_SIZE, width: ITEM_IMG_SIZE, alt: itemDescription || 'Product' })));
};
export default ItemImage;
